export default function LogsIcon() {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M16.6667 8.7002C17.125 8.7002 17.5 9.0752 17.5 9.53353V14.6669C17.5 17.1669 16.25 18.8335 13.3333 18.8335H6.66667C3.75 18.8335 2.5 17.1669 2.5 14.6669V9.53353C2.5 9.0752 2.875 8.7002 3.33333 8.7002H16.6667Z"
        fill="currentColor"
      />
      <path
        d="M13.9584 3.4665V2.1665C13.9584 1.82484 13.6751 1.5415 13.3334 1.5415C12.9918 1.5415 12.7084 1.82484 12.7084 2.1665V3.4165H7.29178V2.1665C7.29178 1.82484 7.00845 1.5415 6.66678 1.5415C6.32512 1.5415 6.04178 1.82484 6.04178 2.1665V3.4665C3.79178 3.67484 2.70011 5.0165 2.53344 7.00817C2.51678 7.24984 2.71678 7.44983 2.95011 7.44983H17.0501C17.2918 7.44983 17.4918 7.2415 17.4668 7.00817C17.3001 5.0165 16.2084 3.67484 13.9584 3.4665Z"
        fill="currentColor"
      />
      <path
        d="M13.0499 15.8917L12.4332 15.275C12.7499 14.7917 12.9416 14.2083 12.9416 13.5833C12.9416 11.8833 11.5582 10.5 9.85823 10.5C8.15823 10.5 6.7749 11.8833 6.7749 13.5833C6.7749 15.2833 8.15823 16.6667 9.85823 16.6667C10.4832 16.6667 11.0666 16.475 11.5499 16.1583L12.1666 16.775C12.2916 16.9 12.4499 16.9583 12.6082 16.9583C12.7666 16.9583 12.9249 16.9 13.0499 16.775C13.2916 16.5333 13.2916 16.1333 13.0499 15.8917Z"
        fill="currentColor"
      />
    </svg>
  );
}
